// PAQUETES
import React from "react";
import { useOutletContext } from "react-router-dom";
import HelmetSEO from '../../componentesEspeciales/helmetSEO';

function Preguntas(){
    const { usuario, cargandoUsuario } = useOutletContext() || {};

    return(
        <>
          <HelmetSEO
            titulo="Preguntas frecuentes | Zervicy"
            descripcion="Resuelve dudas frecuentes sobre pagos, reservas, vendedores, devoluciones y funcionamiento de Zervicy."
          />
        <div>
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">
                <div className="mb-4">
                 <h1 className="h3 fw-bold mb-1">Preguntas frecuentes</h1>
                <p className="text-muted mb-0">
                  Resolvemos las dudas más comunes sobre Zervicy, pagos, compras y devoluciones.
                </p>
                </div>

                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4 p-md-5">
                    <div className="accordion" id="accordionFaq">

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading1">
                          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse1" aria-expanded="true" aria-controls="faqCollapse1">
                            1. ¿De qué trata Zervicy?
                          </button>
                        </h2>
                        <div id="faqCollapse1" className="accordion-collapse collapse show" aria-labelledby="faqHeading1" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Zervicy es un <strong>marketplace de servicios</strong> donde puedes <strong>ofertar</strong> y <strong>contratar</strong> servicios de diferentes categorías,
                            como mudanzas, veterinaria, servicios del hogar y mucho más.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading2">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse2" aria-expanded="false" aria-controls="faqCollapse2">
                            2. ¿Qué métodos de pago tienen?
                          </button>
                        </h2>
                        <div id="faqCollapse2" className="accordion-collapse collapse" aria-labelledby="faqHeading2" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Dependiendo del país, contamos con diferentes métodos de pago. Por ejemplo, para Colombia puedes pagar con
                            <strong> tarjeta de crédito/débito</strong> y otros medios disponibles en el checkout. <strong>Muy pronto</strong> habilitaremos pagos con <strong>cripto</strong>.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading3">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse3" aria-expanded="false" aria-controls="faqCollapse3">
                            3. ¿Cómo realizo la compra de un servicio?
                          </button>
                        </h2>
                        <div id="faqCollapse3" className="accordion-collapse collapse" aria-labelledby="faqHeading3" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            1) Ingresa al marketplace y busca el servicio que necesitas (idealmente en tu ciudad).<br />
                            2) Entra al servicio y elige el paquete: <strong>Básico</strong>, <strong>Premium</strong> o <strong>Avanzado</strong>.<br />
                            3) Haz clic en <strong>Comprar</strong> y completa el pago para confirmar tu solicitud.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading4">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse4" aria-expanded="false" aria-controls="faqCollapse4">
                            4. ¿Cómo me aseguro de que el vendedor realizará el servicio correctamente?
                          </button>
                        </h2>
                        <div id="faqCollapse4" className="accordion-collapse collapse" aria-labelledby="faqHeading4" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Nosotros <strong>retenemos el dinero</strong> mientras el servicio se realiza. Cuando termine, te pediremos que confirmes que todo salió bien
                            (o que nos cuentes si tuviste algún problema); si no nos dices nada, después de un rato entendemos que todo estuvo correcto. Solo cuando el servicio
                            queda confirmado como completado, <strong>procedemos a desembolsar el pago</strong> al vendedor.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading5">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse5" aria-expanded="false" aria-controls="faqCollapse5">
                            5. ¿Por qué debería contratar servicios en Zervicy?
                          </button>
                        </h2>
                        <div id="faqCollapse5" className="accordion-collapse collapse" aria-labelledby="faqHeading5" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Porque aquí puedes ver información clave del vendedor: <strong>perfil verificado</strong>, <strong>calificaciones</strong> y <strong>valoraciones</strong>.
                            Además, las reseñas son de <strong>compradores verificados</strong> (nadie puede reseñar sin haber comprado).
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading6">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse6" aria-expanded="false" aria-controls="faqCollapse6">
                            6. ¿Cómo funcionan las devoluciones y cancelaciones?
                          </button>
                        </h2>
                        <div id="faqCollapse6" className="accordion-collapse collapse" aria-labelledby="faqHeading6" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Las devoluciones no son automáticas. Si ocurre un problema con el servicio, puedes abrir un caso desde tu cuenta explicando lo ocurrido.
                            Nuestro equipo revisará la evidencia y únicamente aprobará devoluciones cuando se confirme un incumplimiento por parte del vendedor.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading7">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse7" aria-expanded="false" aria-controls="faqCollapse7">
                            7. ¿Qué pasa si necesito soporte o reportar un problema?
                          </button>
                        </h2>
                        <div id="faqCollapse7" className="accordion-collapse collapse" aria-labelledby="faqHeading7" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Puedes contactarnos desde la sección de ayuda/soporte de tu cuenta. Te recomendamos incluir el <strong>ID del servicio</strong> y una descripción clara
                            del problema para atenderlo más rápido.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading8">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse8" aria-expanded="false" aria-controls="faqCollapse8">
                            8. ¿Puedo vender servicios en Zervicy?
                          </button>
                        </h2>
                        <div id="faqCollapse8" className="accordion-collapse collapse" aria-labelledby="faqHeading8" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Sí. Puedes crear tu servicio, subir tus fotos, definir paquetes y publicarlo para que otros usuarios lo contraten.
                            A medida que completes servicios, podrás recibir <strong>valoraciones</strong> y mejorar tu reputación.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h2 className="accordion-header" id="faqHeading9">
                          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse9" aria-expanded="false" aria-controls="faqCollapse9">
                            9. Soy vendedor, ¿cuándo me pagan?
                          </button>
                        </h2>
                        <div id="faqCollapse9" className="accordion-collapse collapse" aria-labelledby="faqHeading9" data-bs-parent="#accordionFaq">
                          <div className="accordion-body" style={{ lineHeight: 1.7 }}>
                            Apenas el comprador confirma que el servicio salió bien (o pasan unas horas sin que reporte algún problema), tu pago queda listo para procesarse.
                            Antes de enviarlo, pasa por una breve revisión de seguridad interna que nos ayuda a cuidar tanto tu pago como el de otros vendedores. Una vez enviado,
                            nuestra pasarela de pagos suele tardar <strong>1 a 2 días hábiles</strong> en abonarlo a tu cuenta bancaria. Puedes ver el estado de tus desembolsos en{" "}
                            <strong>"Mis pagos"</strong> dentro de tu cuenta.
                          </div>
                        </div>
                      </div>

                    </div>

                    <div className="alert alert-info mt-4 mb-0" style={{ lineHeight: 1.7 }}>
                      Si tienes una duda que no aparece aquí, escríbenos y con gusto la agregamos a estas preguntas frecuentes.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        </>
    )
}

export default Preguntas;